import { UiKitButtonBase } from '@/fo/ui/kit/button/base';

import { styles } from './ShowMoreButton.styles';

export interface ShowMoreButtonProps {
  onClick: () => void;
  isLoading?: boolean;
  children: React.ReactNode;
}

export function ShowMoreButton({
  onClick,
  isLoading,
  children
}: ShowMoreButtonProps) {
  const slots = styles({ isLoading });

  return (
    <UiKitButtonBase
      onClick={onClick}
      className={slots.base({
        isLoading
      })}
    >
      <span className={slots.loading()} />
      <span className={slots.loadMoreButtonText()}>{children}</span>
    </UiKitButtonBase>
  );
}
